import { PaginatedRequestParams } from 'api';

export enum UploadFilterFormField {
    GroupId = "group_number",
    GroupName = 'GroupName',
    Phone = 'Phone',
    Email = 'Email',
    EventId = "EventId",
    EventName = "EventName",
    Flag = 'Flag'
}

export type UploadFilterFormValues = {
    [UploadFilterFormField.GroupId]: string | undefined;
    [UploadFilterFormField.GroupName]: string | undefined;
    [UploadFilterFormField.Phone]: string | undefined;
    [UploadFilterFormField.Email]: string | undefined;
    [UploadFilterFormField.EventId]: string | undefined;
    [UploadFilterFormField.Flag]: string | undefined;
    [UploadFilterFormField.EventId]: string | undefined;
    [UploadFilterFormField.EventName]: string | undefined;


};

export type UploadFilterFormValuesPaginated = UploadFilterFormValues &
    PaginatedRequestParams;